import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import {getToken} from '../../storage'

export default class GSTR1 extends React.Component {


  constructor(){
    super()
    this.downloadGstr1 = this.downloadGstr1.bind(this)
    this.downloadGstr1Json = this.downloadGstr1Json.bind(this)
    this.downloadGstr1Quarter =  this.downloadGstr1Quarter.bind(this)
    this.downloadGstr3b = this.downloadGstr3b.bind(this)
    this.downloadHsnr = this.downloadHsnr.bind(this)
    this.downloadRateSales = this.downloadRateSales.bind(this)
    this.downloadRatePurchases = this.downloadRatePurchases.bind(this)
    this.downloadReport = this.downloadReport.bind(this)
    this.downloadQuarterReport = this.downloadQuarterReport.bind(this)
    this.state = {}

  }

  componentDidMount() {
    document.title = "GSTR Reports"
  }

  downloadReport(report_type) {
    return   axios({
      url: '/'+report_type+'/?year='+this.refs.year.value+'&month='+this.refs.month.value,
      method: 'get',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({downloadPercent:percentCompleted})
      },
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }

  downloadQuarterReport(report_type) {
    return   axios({
      url: '/'+report_type+'/?year='+this.refs.qyear.value+'&quarter='+this.refs.quarter.value,
      method: 'get',
      responseType: 'blob',
      onDownloadProgress: progressEvent => {
        let percentCompleted = Math.floor((progressEvent.loaded * 100) / progressEvent.total);
        this.setState({downloadPercent:percentCompleted})
      },
      baseURL: API_BASE_URL,
      headers: {
        common: {
          'Authorization': 'Token ' + getToken()
        }
      }
    })
  }


  downloadRateSales() {
    this.setState({submitting_rate_sales:true,})

    this.downloadReport('export_rate_sales').then((response)=> {
      this.setState({submitting_rate_sales:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_rate_sales:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }

  downloadHsnr() {
    this.setState({submitting_hsn:true,})

    this.downloadReport('export_hsn').then((response)=> {
      this.setState({submitting_hsn:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_hsn:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }

  downloadGstr1() {
    this.setState({submitting_gstr1:true,})

    this.downloadReport('export_gstr_1').then((response)=> {
      this.setState({submitting_gstr1:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_gstr1:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }
  downloadGstr1Json() {
    this.setState({submitting_gstr1_json:true})
    this.downloadReport('export_gstr_1_json').then((response)=>{
      this.setState({submitting_gstr1_json:false})
      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_gstr1_json:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }

  downloadRatePurchases() {
    this.setState({submitting_pur:true,})

    this.downloadReport('export_purchases_b2b').then((response)=> {
      this.setState({submitting_pur:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_pur:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }

  downloadGstr1Quarter() {
    this.setState({download_gstr1_quarter:true,})

    this.downloadQuarterReport('export_gstr_1_quarter').then((response)=> {
      this.setState({submitting_gstr1_quarter:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_gstr1_quarter:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }

  downloadGstr3b() {
    this.setState({submitting_gstr3b:true,})

    this.downloadReport('export_gstr_3b').then((response)=> {
      this.setState({submitting_gstr3b:false})

      let disposition = response.headers['content-disposition']
      let filename = decodeURI(disposition.match(/filename="(.*)"/)[1])

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      this.setState({downloadPercent:undefined})
    }).catch((err)=> {
      this.setState({submitting_gstr3b:false, downloadPercent:undefined})
      if(typeof err.response !== "undefined" && err.response.data !== "undefined") {

      }
    })
  }


  


  render() {

    const currentYear = new Date().getFullYear()
const startYear = 2018

const years = []
for (let y = currentYear; y >= startYear; y--) {
  years.push(y)
}

    let download_purchases

    if(this.state.submitting_pur) {
      let dMsg = "Connecting server..."
      if(typeof this.state.downloadPercent !== "undefined") {
          dMsg = <span>Downloading...{this.state.downloadPercent}%</span>
      }
      download_purchases = <div><button className="btn btn-success btn-block" disabled>{dMsg}</button>

        </div>
    }
    else {
      download_purchases = <button className="btn btn-success btn-block"
        onClick={this.downloadRatePurchases}>Download Purchases Excel</button>
    }

    let download_gstr1, download_gstr1_json

    if(this.state.submitting_gstr1) {
      let dMsg = "Connecting server..."
      if(typeof this.state.downloadPercent !== "undefined") {
          dMsg = <span>Downloading...{this.state.downloadPercent}%</span>
      }
      download_gstr1 = <div><button className="btn btn-success btn-block" disabled>{dMsg}</button>
        </div>
    }
    else {
      download_gstr1 = <button className="btn btn-success" onClick={this.downloadGstr1}>GSTR1 Excel</button>
    }
    if(this.state.submitting_gstr1_json) {
      let dMsg = "Connecting server..."
      if(typeof this.state.downloadPercent !== "undefined") {
        dMsg = <span>Downloading ... {this.state.downloadPercent}</span>
      }
      download_gstr1_json = <div><button className="btn btn-success btn-block" disabled>{dMsg}</button></div>
    }
    else {
      download_gstr1_json = <button className="btn btn-success" onClick={this.downloadGstr1Json}>GSTR1 JSON(Beta)</button>
    }

    let download_gstr1_quarter

    if(this.state.submitting_gstr1_quarter) {
      let dMsg = "Connecting server..."
      if(typeof this.state.downloadPercent !== "undefined") {
          dMsg = <span>Downloading...{this.state.downloadPercent}%</span>
      }
      download_gstr1_quarter = <div><button className="btn btn-success btn-block" disabled>{dMsg}</button>

        </div>
    }
    else {
      download_gstr1_quarter = <button className="btn btn-success btn-block" onClick={this.downloadGstr1Quarter}>Download GSTR1 Excel</button>
    }

    let download_gstr3b

    if(this.state.submitting_gstr3b) {
      let dMsg = "Connecting server..."
      if(typeof this.state.downloadPercent !== "undefined") {
          dMsg = <span>Downloading...{this.state.downloadPercent}%</span>
      }
      download_gstr3b = <div><button className="btn btn-success btn-block" disabled>{dMsg}</button>
        </div>
    }
    else {
      download_gstr3b = <button className="btn btn-success btn-block" onClick={this.downloadGstr3b}>Download GSTR3B Excel</button>
    }

    let download_hsnr

    if(this.state.submitting_gstr3b) {
      let dMsg = "Connecting server..."
      if(typeof this.state.downloadPercent !== "undefined") {
          dMsg = <span>Downloading...{this.state.downloadPercent}%</span>
      }
      download_hsnr = <div><button className="btn btn-success btn-block" disabled>{dMsg}</button>
        </div>
    }
    else {
      download_hsnr = <button className="btn btn-success btn-block" onClick={this.downloadHsnr}>Download HSN Excel</button>
    }

    let download_rate_sales

    if(this.state.submitting_gstr3b) {
      let dMsg = "Connecting server..."
      if(typeof this.state.downloadPercent !== "undefined") {
          dMsg = <span>Downloading...{this.state.downloadPercent}%</span>
      }
      download_rate_sales = <div><button className="btn btn-success btn-block" disabled>{dMsg}</button>
        </div>
    }
    else {
      download_rate_sales = <button className="btn btn-success btn-block" onClick={this.downloadRateSales}>Download Rate Sales Excel</button>
    }

    return <div>
    <section className="medium">
    <h3>Download GSTR Reports</h3>
    </section>
    <section className="medium">

    <div className="row">
      <div className="col-md-6">
      <div className="form-horizontal">
        <div className="form-group">
          <div className="col-sm-3 mtop">
          <strong>Year</strong>
            <select ref="year" className="form-control">
            {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
            </select>
          </div>
          <div className="col-sm-3 mtop">
            <strong>Month</strong>
          <select className="form-control" ref="month">
            <option value="01">01 (Jan)</option>
            <option value="02">02 (Feb)</option>
            <option value="03">03 (Mar)</option>
            <option value="04">04 (Apr)</option>
            <option value="05">05 (May)</option>
            <option value="06">06 (Jun)</option>
            <option value="07">07 (Jul)</option>
            <option value="08">08 (Aug)</option>
            <option value="09">09 (Sep)</option>
            <option value="10">10 (Oct)</option>
            <option value="11">11 (Nov)</option>
            <option value="12">12 (Dec)</option>
          </select>
          </div>
          <div className="col-sm-6 mtop">
            <ul className="list-inline">
              <li>{download_gstr1}</li>

            </ul>
            <div>
              {download_gstr3b}
              {download_rate_sales}
              {download_purchases}
            </div>
          </div>
        </div>

      </div>
      </div>
      <div className="col-md-6">
        <div className="form-horizontal">
          <div className="form-group">
            <div className="col-sm-3 mtop">
            <strong>Year</strong>
              <select ref="qyear" className="form-control">
              {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}

              </select>
            </div>
            <div className="col-sm-3 mtop">
              <strong>Quarter</strong>
            <select className="form-control" ref="quarter">
              <option value="q1">Jan - Mar</option>
              <option value="q2">Apr - Jun</option>
              <option value="q3">Jul - Sep</option>
              <option value="q4">Oct - Dec</option>
            </select>
            </div>
            <div className="col-sm-6 mtop ">
              {download_gstr1_quarter}
            </div>
          </div>
        </div>
      </div>
      </div>

      </section>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/report/reports.js